import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderSearchSelect, renderTextArea, renderDatePicker } from '../../Utils/renderField/renderField';
import { connect } from 'react-redux';
import { loadMainVehicles, loadFleetDrivers } from '../../../../redux/modules/expenseTickets';

const TollExpenseForm = (props) => {
  const { handleSubmit, formValues } = props;

  return (
    <form onSubmit={handleSubmit}>
      <div className="container p-4">
        <div className="row mb-3">
          <div className="col-md-6">
            <strong>Driver</strong>
            <Field
              name="driver"
              component={renderSearchSelect}
              className="form-control"
              labelKey="label"
              valueKey="_id"
              loadOptions={loadFleetDrivers}
              allKey
            />
          </div>
          <div className="col-md-6">
            <strong>Vehicle</strong>
            <Field
              name="vehicle"
              component={renderSearchSelect}
              className="form-control"
              labelKey="label"
              valueKey="_id"
              loadOptions={loadMainVehicles}
              allKey
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <strong>Date</strong>
            <Field
              name="startDate"
              component={renderDatePicker}
              type="date"
              defaultValue="2027-12-01"
              className="p-1"
              numberOfMonths={1}
              isOutsideRange={false}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className='col-12'>
            <strong>Reason</strong>
            <Field
              name="reason"
              component={renderTextArea}
              rows={4}
              placeholder="..."
              className="w-100"
            />
          </div>
        </div>

        <div className="w-100 d-flex mb-3">
          <strong>Is Approved?</strong>
          <div className="ml-4 d-flex">
            <div className="d-flex mx-2 align-items-center">
              <Field
                id="background_check_yes"
                name="check"
                component={"input"}
                type="radio"
                value="1"
              />
              <label htmlFor="background_check_yes" className="ml-1 mb-0">
                Approved
              </label>
            </div>
            <div className="d-flex mx-2 align-items-center">
              <Field
                id="background_check_no"
                name="check"
                component={"input"}
                type="radio"
                value="0"
              />
              <label htmlFor="background_check_no" className="ml-1 mb-0">
                Denied
              </label>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className='col-12'>
            <label>{'Notes (optional)'}</label>
            <Field
              name="notes"
              component={renderTextArea}
              rows={4}
              placeholder="Notes..."
              className="w-100"
            />
          </div>
        </div>

        <div className="text-center mt-2">
          <button type="submit" className="btn btn-primary btn-lg w-100">Save</button>
        </div>
      </div>
    </form>
  );
};


const mapStateToProps = (state) => ({
  formValues: (state.form.tollExpenseForm && state.form.tollExpenseForm.values) ? state.form.tollExpenseForm.values : {}
});

export default connect(mapStateToProps)(reduxForm({
  form: 'tollExpenseForm',
  validate: (data) => {
    const errors = {}
    if (!data.driver) errors.driver = "Required Field";
    if (!data.vehicle) errors.vehicle = "Required Field";
    if (!data.startDate) errors.startDate = "Required Field";
    if (!data.reason) errors.reason = "Required Field";
    if (!data.check) errors.check = "Required Field";

    return errors
  }
})(TollExpenseForm));
